import React from 'react';
import { ThemeProvider } from './context/ThemeContext';

const wrapWithProvider = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>;
};

export default wrapWithProvider;
